// @flow
import { GET_ENTITLEMENTS, RECEIVE_ENTITLEMENTS } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    // $FlowFixMe
    [GET_ENTITLEMENTS]: handleReduce(state => state.set('loading', true)),
    [RECEIVE_ENTITLEMENTS]: handleReduce(
        (state, { payload }) =>
            // $FlowFixMe
            state.withMutations(state => state.set('loading', false).set('config', fromJS(payload))),
        // $FlowFixMe
        state => state.set('loading', false)
    )
};

export default handleActions(
    actionHandlers,
    fromJS({
        config: {},
        loading: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/entitlements/index.js